<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="checkAddServiceRequest ? 'Add Ticket' : ''" (addEvent)="addTicketEvent($event)"> </app-breadcrumb>
    <div class="container-fluid">
        <div class="card">

            <div class="card-body p-0">
              <form [formGroup]="searchForm" autocomplete="off">
                <div class="row">
                    <!-- <div class="col-md-2 mt-3 ps-4">
                        <div class="mb-3">
                            <input type="text" class="form-control input-default search-textbox-height" placeholder="Short Description" formControlName="name" autocomplete="off"/>
                        </div>
                    </div> -->
                    <div class="col-md-2 mt-3" *ngIf="checkManagedByFilter">
                        <select2 ngDefaultControl [data]="users" [templates]="template"
                          class="select2" value="" placeholder="Managed by" formControlName="managed_by" (update)="handleSearch('')">
                          <ng-template #template let-data="data">{{data?.name}}</ng-template>
                        </select2>
                    </div>
                    <div class="col-md-3 mt-3">
                        <ng-select ngDefaultControl [items]="properties" class="select2" value="" placeholder="Select Properties"
                            [typeahead]="searchInput$" [virtualScroll]="true" formControlName="property_id" (scrollToEnd)="onScrollToEnd()" (change)="handleSearch('')">
                            <ng-template #template let-data="data">{{data?.name}}</ng-template>
                        </ng-select>
                    </div>
                    <div class="col-md-2 mt-3">
                        <select class="form-select" formControlName="category" (change)="handleSearch('')">
                            <option data-display="Select" value="null" selected>Category</option>
                            <option value="Renovation">Renovation</option>
                            <option value="Repair">Repair</option>
                            <option value="Rent Collection">Rent Collection</option>
                        </select>
                    </div>
                    <div class="col-md-2 mt-3">
                        <select class="form-select" formControlName="status" (change)="handleSearch('')">
                            <option value="null" selected disabled>Status</option>
                            <option *ngFor="let status of defaultStatusValues" [value]="status">{{ status }}</option>
                        </select>
                    </div>
                    <div class="col-md-2 mt-3">
                        <select class="form-select" formControlName="priority" (change)="handleSearch('')">
                            <option data-display="Select" value="null" selected>Priority</option>
                            <option value="high">High</option>
                            <option value="medium">Medium</option>
                            <option value="low">Low</option>
                        </select>
                    </div>
                    <div class="col-md-1 mt-3 pe-4">
                        <button class="btn btn-danger btn-sm float-end" type="button" (click)="resetSearchForm()" [disabled]="!disableClear">Clear</button>
                    </div>
                    <!-- <div class="col-md-1 mt-4 p-0">
                        <button class="btn btn-primary btn-sm  float-start" type="submit">Search</button>
                    </div> -->

                </div>
              </form>


                <div class="row">
                        <div class="col-xl-12">
                        <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">
                            <table id="empoloyees-tbl" class="table mb-0" matSort (matSortChange)="sortData($event)">
                                <thead>
                                    <tr>
                                        <th mat-sort-header="created_date">Created Date</th>
                                        <th mat-sort-header="property_name">Property</th>
                                        <th mat-sort-header="category">Category</th>
                                        <th mat-sort-header="sub_category">Sub Category</th>
                                        <!-- <th mat-sort-header="short_description">Short Description</th> -->
                                        <!-- <th mat-sort-header="created_date">Created Date</th> -->
                                        <!-- <th mat-sort-header="needed_at">Need By Date</th> -->
                                        <!-- <th mat-sort-header="apprx_cost">Approximate Cost</th> -->
                                        <th mat-sort-header="priority">Priority</th>
                                        <!-- <th mat-sort-header="description">Description</th> -->
                                        <th mat-sort-header="status">Status</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for(item of allData.data; track item.id){
                                    <tr>
                                        <td>
                                            <span>{{ item.created_date | date:'dd-MM-yyyy' }}</span>
                                        </td>
                                        <td>{{ item.property_name }}</td>
                                        <td>{{ item.category }}</td>
                                        <td>
                                            <span>{{ item.sub_category }}</span>
                                        </td>
                                        <!-- <td><span class="short-description">{{ item.short_description }}</span></td> -->
                                        <!-- <td>
                                            <span>{{ item.created_date }}</span>
                                        </td> -->
                                        <!-- <td>
                                            <span>{{ item.needed_at }}</span>
                                        </td> -->
                                        <!-- <td>
                                            <span>{{ item.apprx_cost }}</span>
                                        </td> -->
                                        <td>
                                            <span>{{ item.priority }}</span>
                                        </td>
                                        <!-- <td>
                                            <span>{{ item.description }}</span>
                                        </td> -->
                                        <td>
                                            @if(item.status == 'Pending'){
                                            <span class="badge badge-danger light border-0">{{item.status}}</span>
                                            } @else {
                                            <span class="badge badge-success light border-0">{{item.status}}</span>
                                            }
                                        </td>

                                        <td class="text-center">
                                            <!-- <div class="img-wrapper" *ngIf="checkEditServiceRequest">
                                                <button type="button" class="btn btn-info shadow btn-xs sharp mb-1 me-2" (click)="openCenter(content)"><i class="fa fa-refresh"></i></button>
                                                <div class="tooltip-text">Update Status</div>
                                            </div> -->
                                            <div class="img-wrapper">
                                                <button type="button" class="btn btn-primary shadow btn-xs sharp mb-1 me-2" (click)="viewTicketDetails(item.id)">
                                                    <i class="fa fa-eye"></i></button>
                                                <div class="tooltip-text">View</div>
                                            </div>
                                            <div class="img-wrapper" *ngIf="item.status !='Closed' && checkEditServiceRequest">
                                                <button type="button" class="btn btn-info shadow btn-xs sharp mb-1 me-2" (click)="selectTicket(item.id)">
                                                    <i class="fa fa-edit"></i></button>
                                                <div class="tooltip-text">Edit</div>
                                            </div>
                                            <div class="img-wrapper" *ngIf="checkDeleteServiceRequest">
                                                <button type="button" class="btn btn-danger shadow btn-xs sharp mb-1 me-2" (click)="deleteTicket(item.id)">
                                                    <i class="fa fa-trash"></i></button>
                                                <div class="tooltip-text">Delete</div>
                                            </div>
                                        <!-- <span class="badge badge-success light border-0 m-1 c-pointer" (click)="openCenter(content)">Update Status</span> -->
                                        <!-- <span class="badge badge-success light border-0 m-1 c-pointer" (click)="selectTicket(item)">Edit</span> -->
                                        <!-- <span class="badge badge-danger light border-0">Delete</span> -->
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                            <div class="dataTables_info" id="example5_info" role="status" aria-live="polite">Showing {{allData.startPage}} to
                            {{allData.endPage}} of {{ totalPage }} entries</div>
                            <div class="dataTables_paginate paging_simple_numbers pt-2">
                                <app-pagination [totalPage]="pageCount" [page]="page" (newPage)="pageChange($event)"></app-pagination>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div #addTicketButton class="offcanvas offcanvas-end customeoff {{ ticketadd_edit ? 'show':''}}" tabindex="-1" id="ticketadd_edit" data-bs-backdrop="static">
    <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">{{ isEditTicket ? "Edit" : "Add" }} Ticket</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"  (click)="tikcetClose()">
          <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="container-fluid" >
      <form [formGroup]="addTicketForm" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row">
            <div class="col-xl-12 mb-3">
                <label for="exampleFormControlInput1-1" class="form-label">Property<span class="text-danger">*</span></label>
                <ng-select ngDefaultControl [items]="properties" class="select2" value="" placeholder="Select Properties"
                            [typeahead]="searchInput$" [virtualScroll]="true" formControlName="property_id" (scrollToEnd)="onScrollToEnd()" (change)="handleSearch('')">
                            <ng-template #template let-data="data">{{data?.name}}</ng-template>
                </ng-select>
                <div *ngIf="addTicketForm?.get('property_id')?.invalid && addTicketForm?.get('property_id')?.touched" class="required">
                   Property is required
                </div>
              </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Category<span class="text-danger">*</span></label>
            <select class="form-select" formControlName="category">
                <option  data-display="Select" value="" selected>Please select</option>
                <option value="Renovation">Renovation</option>
                <option value="Repair">Repair</option>
                <option value="Rent Collection">Rent Collection</option>
            </select>
            <div *ngIf="addTicketForm?.get('category')?.invalid && addTicketForm?.get('category')?.touched" class="required">
               Category is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Sub Category<span class="text-danger">*</span></label>
            <select2 ngDefaultControl [data]="subCategories" [templates]="template" class="select2" value="" placeholder="Sub category" formControlName="sub_category">
                <ng-template #template let-data="data">{{data?.name}}</ng-template>
            </select2>
            <div *ngIf="addTicketForm?.get('sub_category')?.invalid && addTicketForm?.get('sub_category')?.touched" class="required">
               Sub Category is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-3" class="form-label">Priority<span class="text-danger">*</span></label>
              <select class="form-select" formControlName="priority">
                <option  data-display="Select" value="" selected>Please select</option>
                <option value="high">High</option>
                <option value="medium">Medium</option>
                <option value="low">Low</option>
            </select>
              <div *ngIf="addTicketForm?.get('priority')?.invalid && addTicketForm?.get('priority')?.touched" class="required">
                Please select priority
            </div>
          </div>
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-4" class="form-label">Need By Date<span class="text-danger">*</span></label>
              <input type="date" class="form-control" id="exampleFormControlInput1-3" placeholder="select date" formControlName="needed_at">
          </div>
          <div class="col-xl-6 mt-3 mb-4">
            <div class="d-flex gap-2">
              <div class="col-xl-4 w-50">
                <label for="exampleFormControlInput1-1" class="form-label">Tenant Visibility</label>
              </div>
              <div class="col-xl-2 w-50">
                <input type="checkbox" class="form-check-input" formControlName="tenant_visible">
              </div>
            </div>
          </div>
          <div class="col-xl-6 mt-3 mb-4">
            <div class="d-flex gap-2">
              <div class="col-xl-4 w-50">
                <label for="exampleFormControlInput1-1" class="form-label">Owner Visibility</label>
              </div>
              <div class="col-xl-2 w-50">
                <input type="checkbox" class="form-check-input" formControlName="owner_visible">
              </div>
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Approximate Cost</label>
            <input type="email" class="form-control" id="exampleFormControlInput1-3" placeholder="0" formControlName="apprx_cost">
          </div>

          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-4" class="form-label">Choose File(s)</label>
            <input type="file" class="form-control" id="exampleFormControlInput1-3" multiple formControlName="files" (change)="uploadImages($event)">
          </div>
        <div class="mb-3" [ngClass]="isEditTicket ? 'col-md-6' : 'col-md-12'">
            <label for="exampleFormControlInput1-3" class="form-label">Short Description<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="Short Description" formControlName="short_description">
            <div *ngIf="addTicketForm?.get('short_description')?.errors && addTicketForm?.get('short_description')?.touched" class="required">
                Provide short description
            </div>
        </div>
        <div class="col-xl-6 mb-3" *ngIf="isEditTicket">
            <label for="exampleFormControlInput1-4" class="form-label">Status</label>
            <select class="form-control" formControlName="status">
                <option value="null" selected disabled>Status</option>
                <option *ngFor="let status of defaultStatusValues" [value]="status">{{ status }}</option>
            </select>
        </div>
        <div class="col-xl-12 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Description<span class="text-danger">*</span></label>
            <ckeditor [editor]="Editor" formControlName="description"></ckeditor>
            <div *ngIf="addTicketForm?.get('description')?.errors && addTicketForm?.get('description')?.touched" class="required">
                Provide ticket description
            </div>
        </div>

        <div class="col-xl-12 mb-3" *ngIf="uploadedImages?.length && isEditTicket">
            <div *ngFor="let img of uploadedImages; let i = index">
                <div class="row">
                    <div class="col-md-6">
                        <p class="badge light badge-light"> {{ img.original_name }} </p>
                    </div>
                    <div class="col-md-6">
                        <p class="badge light badge-primary me-3 ms-3 c-pointer" (click)="viewImage(img.upload_key)"> View </p>
                        <p class="badge light badge-danger c-pointer" (click)="deleteImage(img.id)"> Delete </p>
                    </div>
                </div>
            </div>
        </div>

      </div>
              <div>
                  <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="addTicketForm.invalid || loadingService.isLoading()">Submit</button>
                  <button class="btn btn-danger lightme-1" type="button" (click)="tikcetClose()">Cancel</button>
              </div>
      </form>
        </div>
    </div>
  </div>
  @if(ticketadd_edit){
    <div class="offcanvas-backdrop fade show" (click)="ticketPopupOpen()"></div>
  }

  <ng-template #content let-modal>
    <form [formGroup]="updateStatusForm" (ngSubmit)="updateStatus()" autocomplete="off">
    <div class="modal-header">
      <h5 class="modal-title">Update Status</h5>
      <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
            <h6>Status</h6>
            <select class="form-control" formControlName="update_status">
                <option value="null" selected disabled>Update Status</option>
                <option *ngFor="let status of defaultStatusValues" [value]="status">{{ status }}</option>

            </select>
            <div *ngIf="updateStatusForm?.get('update_status')?.invalid && updateStatusForm?.get('update_status')?.touched" class="required">
                Status is required
            </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger btn-sm" (click)="closeModal()">Close</button>
        <button type="button" class="btn btn-primary btn-sm" [disabled]="updateStatusForm.invalid || loadingService.isLoading()">Save</button>
    </div>
    </form>
</ng-template>

<div #viewTicketOffcanvas class="offcanvas offcanvas-end customeoff {{ viewTicket ? 'show':''}}" tabindex="-1" id="viewTicket" data-bs-backdrop="static">
    <div class="offcanvas-header">
        <h5 class="modal-title" id="#viewTicketModal">Service Request Details</h5>
        <button type="button" class="btn-close" (click)="closeViewTicket()">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
    <div class="offcanvas-body">
        <div class="container-fluid" *ngIf="selectedTicketDetails">
            <div class="row mb-3">
                <div class="col-xl-12 mb-3">
                    <label class="form-label"><strong>Property:</strong></label>
                    <p>{{ selectedTicketDetails.property_name }}</p>
                </div>
                <div class="col-xl-6 mb-3">
                    <label class="form-label"><strong>Category:</strong></label>
                    <p>{{ selectedTicketDetails.category }}</p>
                </div>
                <div class="col-xl-6 mb-3">
                    <label class="form-label"><strong>Sub Category:</strong></label>
                    <p>{{ selectedTicketDetails.sub_category }}</p>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-xl-6 mb-3">
                    <label class="form-label"><strong>Priority:</strong></label>
                    <p>{{ selectedTicketDetails.priority }}</p>
                </div>
                <div class="col-xl-6 mb-3">
                    <label class="form-label"><strong>Status:</strong></label>
                    <p>
                        @if(selectedTicketDetails.status == 'Pending'){
                        <span class="badge badge-danger light border-0">{{selectedTicketDetails.status}}</span>
                        } @else {
                        <span class="badge badge-success light border-0">{{selectedTicketDetails.status}}</span>
                        }
                    </p>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-xl-6 mb-3">
                    <label class="form-label"><strong>Created Date:</strong></label>
                    <p>{{ selectedTicketDetails.created_date | date:'dd-MM-yyyy' }}</p>
                </div>
                <div class="col-xl-6 mb-3" *ngIf="selectedTicketDetails.needed_at">
                    <label class="form-label"><strong>Need By Date:</strong></label>
                    <p>{{ selectedTicketDetails.needed_at | date:'dd-MM-yyyy' }}</p>
                </div>
            </div>
            <div class="row mb-3" *ngIf="selectedTicketDetails.apprx_cost">
                <div class="col-xl-12 mb-3">
                    <label class="form-label"><strong>Approximate Cost:</strong></label>
                    <p>{{ selectedTicketDetails.apprx_cost }}</p>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-xl-12 mb-3">
                    <label class="form-label"><strong>Short Description:</strong></label>
                    <p>{{ selectedTicketDetails.short_description }}</p>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-xl-12 mb-3">
                    <label class="form-label"><strong>Description:</strong></label>
                    <div [innerHTML]="selectedTicketDetails.description"></div>
                </div>
            </div>
            <div class="row mb-3" *ngIf="selectedTicketDetails.uploads?.length">
                <div class="col-xl-12 mb-3">
                    <label class="form-label"><strong>Attachments ({{ selectedTicketDetails.uploads.length }}):</strong></label>
                    <div class="mt-2">
                        <div *ngFor="let img of selectedTicketDetails.uploads; let i = index" class="mb-2">
                            <div class="row align-items-center">
                                <div class="col-md-1 text-center">
                                    <i class="fa fa-file-text-o fa-2x text-primary"></i>
                                </div>
                                <div class="col-md-7">
                                    <p class="mb-0"><strong>{{ img.original_name }}</strong></p>
                                    <small class="text-muted">File {{ i + 1 }}</small>
                                </div>
                                <div class="col-md-4 text-end">
                                    <button type="button" class="btn btn-primary btn-xs me-2" (click)="viewImage(img.upload_key)">
                                        <i class="fa fa-eye me-1"></i> View
                                    </button>
                                </div>
                            </div>
                            <hr *ngIf="i < selectedTicketDetails.uploads.length - 1">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3" *ngIf="!selectedTicketDetails.uploads?.length">
                <div class="col-xl-12 mb-3">
                    <label class="form-label"><strong>Attachments:</strong></label>
                    <p class="text-muted">No attachments available</p>
                </div>
            </div>
        </div>
    </div>
</div>
@if(viewTicket){
    <div class="offcanvas-backdrop fade show" (click)="closeViewTicket()"></div>
}
